import { useEffect, useState } from "react";
import { X, Info, CheckCircle2, AlertTriangle, AlertOctagon } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../contexts/AuthContext";

const STYLES = {
  info: { bg: "bg-primary/10", text: "text-primary", border: "border-primary/30", Icon: Info },
  success: { bg: "bg-emerald-100", text: "text-emerald-800", border: "border-emerald-300", Icon: CheckCircle2 },
  warning: { bg: "bg-amber-100", text: "text-amber-900", border: "border-amber-300", Icon: AlertTriangle },
  alert: { bg: "bg-red-100", text: "text-red-900", border: "border-red-300", Icon: AlertOctagon },
};

export default function AnnouncementsBanner() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [dismissed, setDismissed] = useState(() => {
    try { return JSON.parse(localStorage.getItem("demka_dismissed_ann") || "[]"); } catch { return []; }
  });

  useEffect(() => {
    const role = user?.role && ["client", "professional", "entrepreneur", "organism"].includes(user.role)
      ? (user.role === "client" ? "client" : "provider")
      : null;
    const params = role ? { role } : {};
    api.get("/announcements", { params }).then((r) => setItems(r.data)).catch(() => {});
  }, [user]);

  const dismiss = (id) => {
    const n = [...dismissed, id];
    setDismissed(n);
    localStorage.setItem("demka_dismissed_ann", JSON.stringify(n));
  };

  const visible = items.filter((a) => !dismissed.includes(a.id));
  if (visible.length === 0) return null;

  return (
    <div data-testid="announcements-banner">
      {visible.map((a) => {
        const s = STYLES[a.type] || STYLES.info;
        return (
          <div key={a.id} className={`${s.bg} ${s.border} border-b`}>
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex items-center justify-between gap-3 text-sm">
              <div className={`flex items-center gap-2 ${s.text}`}>
                <s.Icon className="w-4 h-4 flex-shrink-0" />
                <strong className="font-display">{a.title}</strong>
                <span className="text-foreground/80 hidden sm:inline">— {a.body}</span>
                {a.cta_url && (
                  <a href={a.cta_url} target="_blank" rel="noreferrer" className={`underline font-medium ${s.text}`}>
                    {a.cta_label || "En savoir plus"}
                  </a>
                )}
              </div>
              <button onClick={() => dismiss(a.id)} className="p-1 hover:bg-black/5 rounded-full" aria-label="Fermer">
                <X className="w-4 h-4" />
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
}
